import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AppContainer from "../Structure/AppContainer";
import RoleContext from "../../Context/RoleContext";
import CreateRole from "./CreateRole";
import useStateCallback from "../../util/customHooks/useStateCallback";
export default function RoleCards() {
  const { roleList = [] } = useContext(RoleContext);
  const navigate = useNavigate();
  const goToPermissions = (role_id) => {
    navigate(`/users/roles/permissions/${role_id}`);
  };
  // Modals
  const [createRole, setcreateRole] = useStateCallback(false);
  // Modal handlers
  const handlecreateRole = (data) => {
    setcreateRole(false, () => setcreateRole(<CreateRole data={data} />));
  };
  return (
    <AppContainer title="Roles">
      {/* Create Role Button */}
      {createRole}
      <div className="row mb-4">
        <div className="col-12 text-end">
          <button
            className="btn btn-primary shadow-sm"
            onClick={handlecreateRole}
          >
            <i className="fa fa-plus me-2"></i> Create Role
          </button>
        </div>
      </div>
      {/* Role Cards */}
      <div className="row g-4">
        {roleList.length > 0 ? (
          roleList.map((role) => (
            <div key={role.role_id} className="col-md-4 col-sm-6">
              <div
                className="card h-100 shadow-lg border-0"
                style={{
                  borderRadius: "15px",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  background: "linear-gradient(135deg, #1E3C72, #3373e2ff)",
                  color: "#ffffff",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow =
                    "0 12px 20px rgba(0,0,0,0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 10px rgba(0,0,0,0.15)";
                }}
              >
                <div className="card-body d-flex flex-column justify-content-between text-center">
                  <div>
                    <h5 className="card-title fw-bold text-uppercase">
                      {role.role_name}
                    </h5>
                  </div>
                  <button
                    onClick={() => goToPermissions(role.role_id)}
                    className="btn fw-bold mt-3"
                    style={{
                      background: "linear-gradient(135deg, #4facfe, #00f2fe)",
                      color: "#fff",
                      borderRadius: "10px",
                      border: "none",
                      padding: "8px 16px",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 15px rgba(0,0,0,0.25)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0,0,0,0.15)";
                    }}
                  >
                    Allocate Permission
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <p className="text-center text-muted fs-5">No roles found.</p>
          </div>
        )}
      </div>
    </AppContainer>
  );
}
